import React, { useState } from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { FaUsers, FaUserFriends, FaMapMarkerAlt, FaCalendarAlt, FaFileAlt } from "react-icons/fa"; // Icons
import ProfileBackgoundImage from "../../assets/images/profile-bg.svg";
import ProfileImage from "../../assets/images/p-image.svg";
import goldBadge from "../../assets/images/gold.svg";
import { RiImageEditFill } from "react-icons/ri";
import PostList from "../../components/Post";
import SuggestedFollows from "../../components/SuggestedFollow";
import MyFollow from "../../components/MyFollow";
import MyClubsComponent from "../../components/MyClubs";
import CreatePost from "../../components/CreatePost";


const currentUser = "Rose Winslet"; // Replace with actual logged-in user

const Profile = ({ user = { name: "Rose Winslet" } }) => {
  // State to track follow/unfollow status
  const [isFollowing, setIsFollowing] = useState(false);
  const [coverImage, setCoverImage] = useState(ProfileBackgoundImage); // State for cover image

  // Toggle function for Follow/Unfollow
  const handleToggle = () => {
    setIsFollowing(!isFollowing);
  };

  // Handle Cover Photo Change
  const handleCoverChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCoverImage(imageUrl);
    }
  };

  return (
    <div className="profile-page-element">
        <h2 className="mb-20">Profile</h2>
        <Card className="profile-page-card">
        {/* Cover Image Section with "Change Cover Photo" button */}
        <div className="cover-image">
            <img src={coverImage} alt="Cover" className="cover-img" />
            
            {/* Show "Change Cover Photo" only if it's the logged-in user */}
            {user.name && user.name.trim().toLowerCase() === currentUser.trim().toLowerCase() && (
                <div className="change-cover-btn">
                    <input 
                    type="file" 
                    id="coverUpload" 
                    accept="image/*" 
                    onChange={handleCoverChange} 
                    hidden 
                    />
                    <label htmlFor="coverUpload" className="change-cover-icon">
                    <RiImageEditFill />
                    </label>
                </div>
                )}
        </div>

        {/* Profile Section */}
        <Card.Body>
            <div className="align-items-center profile-page-wraper">
            <div className="profile-page-pic">
                {/* Profile Picture */}
                <div className="profile-page-pic-inner">
                <img src={ProfileImage} alt="Profile" className="profile-page-img" />
                </div>
            </div>
            <div className="profile-page-top">
                <div className="profile-page-info">
                <h3 className="profile-name">
                    {user.name || "Rose Winslet"} 
                    <Badge bg="gold">
                    <img src={goldBadge} alt="gold" /> Gold Member
                    </Badge>
                </h3>
                <p className="profile-page-handle">@{user.username || "rosewinslet"}</p>
                </div>

                {/* Action Button */}
                <div className="action-buttons">
                {user.name && user.name.trim().toLowerCase() !== currentUser.trim().toLowerCase() && (  
                <Button
                    variant="outline-primary"
                    className="toggle-follow-btn"
                    onClick={handleToggle}
                >
                    {isFollowing ? "UNFOLLOW" : "FOLLOW"}
                </Button>
                )}
                </div>
            </div>
            </div>

            {/* ✅ New Stats Section */}
            <div className="profile-stats-container">
            {/* Left Side Stats */}
            <div className="profile-stats">
                <span><FaUsers className="stat-icon" /> <strong>{user.followers || "900k"}</strong> Followers</span>
                <span><FaUserFriends className="stat-icon" /> <strong>{user.following || "56k"}</strong> Following</span>
                <span><FaMapMarkerAlt className="stat-icon" /> {user.location || "Boston, UK"}</span>
                <span><FaFileAlt className="stat-icon" /> <strong>{user.posts || "9k"}</strong> Posts & 2 Polls</span>
                <span><FaCalendarAlt className="stat-icon" /> Joined on <strong>{user.joined || "Jan 06, 2022"}</strong></span>
            </div>

            {/* Right Side Bio */}
            <div className="bio-section">
                <h5>Bio</h5>
                <p>{user.bio || "Creator of Acadelfer. Building factory. BJJ enjoyer. Indie Hacking my way to financial freedom."}</p>
            </div>
            </div>
        </Card.Body>
        </Card>
        <div className="right-panel-inner mt-20">
            <div className="post-section">
                <CreatePost/>
                <PostList filterByUser="Rose Winslet" />
            </div>
            <div className="right-side-bar three-child">
                <MyClubsComponent title="My Clubs" />
                <SuggestedFollows title="My Followers (60k)"/>
                <MyFollow title="Following (3.2k)"/>
            </div>
        </div>
    </div>
  );
};

export default Profile;
